var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownLong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 366.312C37.811 357.555 46.452 351.895 55.998 351.895H136V24C136 10.75 146.75 0 160 0S184 10.75 184 24V351.895H264C273.547 351.895 282.188 357.555 286.002 366.312C289.813 375.066 288.078 385.262 281.594 392.25L177.594 504.324C168.094 514.559 151.905 514.559 142.407 504.324L38.405 392.25C31.92 385.262 30.186 375.066 34 366.312Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownLong);
export default __webpack_public_path__ + "static/media/down-long.603c91d4c400e57a03ca6157c24761d8.svg";
export { ForwardRef as ReactComponent };